import {
  MEDIA_ATTACHMENT_FIELD_DEFAULT_PROPS,
  MediaAttachmentFieldProps,
} from '../core-field/media-attachment-field-props'

export const UI2_FILE_UPLOAD_FIELD_DEFAULT_PROPS: Partial<UI2FileUploadFieldProps> = {
  ...MEDIA_ATTACHMENT_FIELD_DEFAULT_PROPS,
  /** @platform web — accepted MIME types for the file picker. */
  accept: 'image/*,application/pdf',
}

export interface UI2FileUploadFieldProps extends MediaAttachmentFieldProps {
  /** HTML `accept` attribute for the underlying file input (DW). Defaults to broad (images + PDFs). */
  accept?: string
}
